export default __webpack_public_path__ + "static/media/who.e9349558.jpg";